import { DECLINATION_REASONS_FIELD_NAMES } from './DeclinationReasons.constants';

export const buildDeclinationPayload = formData => ({
  declination_details: {
    declined_fields: formData?.[DECLINATION_REASONS_FIELD_NAMES.DeclinedFields] || [],
    declination_notes: formData?.[DECLINATION_REASONS_FIELD_NAMES.DeclinationNotes] || ''
  }
});

export const getDeclinationFormInitialValues = declinationDetails => ({
  [DECLINATION_REASONS_FIELD_NAMES.DeclinedFields]: declinationDetails?.declined_fields || [],
  [DECLINATION_REASONS_FIELD_NAMES.DeclinationNotes]: declinationDetails?.declination_notes || ''
});
